<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page08"></a>
<a id="page09"></a>
<p class="dedicationText"><em class="italic">For Richard Howard<br/> and David Alexander, dear friends</em></p>
<a id="page10"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4f189f2a